import toast from "react-hot-toast";

/**
 * Success toast for one-click archive actions (canvases, chats). The optional
 * Undo action restores in place, replacing a pre-archive confirmation dialog —
 * everything archived stays restorable anyway.
 */
export function showMovedToTrashToast(onUndo?: () => void) {
  toast.success(
    (t) => (
      <span className="flex items-center gap-3">
        Archived.
        {onUndo && (
          <button
            type="button"
            onClick={() => {
              toast.dismiss(t.id);
              onUndo();
            }}
            className="font-medium underline underline-offset-2 hover:opacity-80"
          >
            Undo
          </button>
        )}
      </span>
    ),
    { duration: 5000 },
  );
}
